import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c78ff090"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal-title"
}




export default /*#__PURE__*/_defineComponent({
  __name: 'ModalDialog',
  props: {
	visible: {
		type: Boolean,
		required: false,
		default: false
	},
	title: {
		type: String,
		required: false,
		default: null
	}
},
  emits: ["onClose"],
  setup(__props, { emit }) {

const props = __props;





function close() {
	emit("onClose");
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "modal-fade" }, {
    default: _withCtx(() => [
      (_unref(props).visible)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "modal-dialog-bg d-flex align-items-center justify-content-center",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (close()))
          }, [
            _createElementVNode("div", {
              class: "modal-main",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($event.stopPropagation()))
            }, [
              (_unref(props).title)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(props).title), 1))
                : _createCommentVNode("", true),
              _renderSlot(_ctx.$slots, "default")
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})